<div class="grid align-items-center mb-2" data-cy="my-mentions">
	<div class="col-6">
		Select mentions to mark as read or delete
	</div>
	<div class="col-6 text-right">
		<button
			(click)="deleteSelected()"
			[style]="{ 'max-width': '180px' }"
			class="p-button-primary"
			icon="pi pi-trash"
			label="Remove Selected"
			pButton
		></button>
	</div>
</div>

<div class="custom-card">
	<div *ngIf="isLoading" class="text-center py-4">Loading...</div>
	<div *ngIf="isRemovingMentions" class="text-center py-4">Wait...</div>
	<p-table
		data-cy="my-mentions-table"
		[(selection)]="selectedMentions"
		[loading]="isLoading"
		[paginator]="true"
		[rows]="20"
		[style]="{ 'font-size': '12px' }"
		[value]="mentions"
		dataKey="id"
		selectionMode="multiple"
		showCurrentPageReport="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
	>
		<ng-template pTemplate="header">
			<tr>
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="createdDate">Created Date
					<p-sortIcon field="createdDate"></p-sortIcon>
				</th>
				<th pSortableColumn="dueDate">Due By
					<p-sortIcon field="dueDate"></p-sortIcon>
				</th>
				<th pSortableColumn="workflowName">Task Name
					<p-sortIcon field="workflowName"></p-sortIcon>
				</th>
				<th pSortableColumn="commentText">Comment
					<p-sortIcon field="commentText"></p-sortIcon>
				</th>
				<th pSortableColumn="readDate">Read Date
					<p-sortIcon field="readDate"></p-sortIcon>
				</th>
				<th>Action</th>
			</tr>
		</ng-template>

		<ng-template let-mention pTemplate="body">
			<tr>
				<td>
					<p-tableCheckbox [value]="mention"></p-tableCheckbox>
				</td>
				<td>{{ mention.createdDate |  DatePropertyTimezone: false : true }}</td>
				<td>{{ mention.dueDate |  DatePropertyTimezone: false : true }}</td>
				<td>{{ mention.workflowName }}</td>
				<td>{{ mention.commentText }}</td>
				<td>{{ mention.readDate ? (mention.readDate |  DatePropertyTimezone: false : true) : 'Unread' }}</td>
				<td class="text-center" title="click on the arrow to go to task">
					<a (click)="goToMention(mention, $event)" title="go to task">
						<i class="pi pi-arrow-right"></i>
					</a>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="7">No records found</td>
			</tr>
		</ng-template>
	</p-table>
</div>
